// extracted by mini-css-extract-plugin
module.exports = {"menu":"CustomContextMenu__menu___3iI6L","menuItem":"CustomContextMenu__menuItem___36i0f"};